import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { Icon, Text } from '@/ui'
import { mtc, TextColors, TypographyStyles } from '@/styles'
import { AttachedFiles } from './AttachedFiles'
import type { AttachedFile } from '../lib/types'

interface TicketFilesProps {
  attachedFiles?: string[]
  droppedAttachments?: string[]
}

const toAttachedFile = (fileName: string): AttachedFile => ({
  fileName,
  contentType: '',
})

const DroppedAttachment = ({ fileName }: { fileName: string }) => (
  <div
    className={mtc(
      'flex items-start gap-3 rounded-[8px] border px-3 py-2',
      'border-red-200 bg-red-25'
    )}
  >
    <Icon
      icon={faTriangleExclamation}
      color="text-red-400"
      className="mt-0.5 shrink-0"
    />
    <div className="flex min-w-0 flex-col gap-0.5">
      <Text
        variant={TypographyStyles.LABEL_SM}
        color={TextColors.HEADER}
        className="truncate"
        title={fileName}
      >
        {fileName}
      </Text>
      <Text variant={TypographyStyles.BODY_XS} color={TextColors.DANGER}>
        This file was not attached. You can send it again.
      </Text>
    </div>
  </div>
)

export const TicketFiles = ({
  attachedFiles,
  droppedAttachments,
}: TicketFilesProps) => (
  <>
    <AttachedFiles files={(attachedFiles ?? []).map(toAttachedFile)} />
    {droppedAttachments && droppedAttachments.length > 0 && (
      <div className="flex flex-col gap-2 pt-2">
        {droppedAttachments.map((fileName, index) => (
          <DroppedAttachment key={`${fileName}-${index}`} fileName={fileName} />
        ))}
      </div>
    )}
  </>
)
